// @flow
import type {Node} from 'react';
import type {Status} from 'bfu-auth-client/src/login/types/Types.js';

import React from 'react';
import Message from 'react-goose/lib/Message';

type Props = {
    status?: Status
};

const StatusMessage =  ({status}: Props): Node => {
    if(!status) {
        return null;
    }
    return <Message spruceName="BlueflagAuthFormMessage" modifier={status.modifier}>{status.message}</Message>;
};

export default StatusMessage;